import * as React from 'react'
import { useCallback } from 'react'
import Button from '@mui/material/Button'
import { useFormikContext } from 'formik'
import { filtersInitValues } from './formConfig'

export function ClearAllButton() {
  const { setValues } = useFormikContext()

  const clearAll = useCallback(
    () =>
      setValues(
        {
          ...filtersInitValues,
          startDate: null,
          startTime: '',
          endTime: '',
          endDate: null,
        },
        false,
      ),
    [setValues],
  )

  return (
    <Button data-test-id="filters-clearAllBtn" onClick={clearAll}>
      Clear All
    </Button>
  )
}
